import { gql } from '@apollo/client';

export const getSafetyPageQuery = gql`
    {
        getSafetyPage {
            id
            name
            value
        }
    }
`;

export const updateSafetyPageMutation = `mutation (
    $heroBadge: String,
    $heroTitle: String,
    $heroSubtitle: String,
    $heroDescription: String,
    $heroBackgroundImage: String,
    $feature1Title: String,
    $feature1Description: String,
    $feature1Icon: String,
    $feature2Title: String,
    $feature2Description: String,
    $feature2Icon: String,
    $feature3Title: String,
    $feature3Description: String,
    $feature3Icon: String,
    $bottomCardTitle: String,
    $bottomCardText: String
) {
    updateSafetyPage (
        heroBadge: $heroBadge,
        heroTitle: $heroTitle,
        heroSubtitle: $heroSubtitle,
        heroDescription: $heroDescription,
        heroBackgroundImage: $heroBackgroundImage,
        feature1Title: $feature1Title,
        feature1Description: $feature1Description,
        feature1Icon: $feature1Icon,
        feature2Title: $feature2Title,
        feature2Description: $feature2Description,
        feature2Icon: $feature2Icon,
        feature3Title: $feature3Title,
        feature3Description: $feature3Description,
        feature3Icon: $feature3Icon,
        bottomCardTitle: $bottomCardTitle,
        bottomCardText: $bottomCardText
    ) {
        status
    }
}`;
